import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { isJestTest } from '../../test-helpers/isJestTest';
import { sentryCaptureException } from '../../utilities/sentryCaptureException';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  PreviousTaskCommentsCollection,
  PreviousTaskCommentsDocument,
} from './previousTaskComments.types';

export const usePreviousTaskComments = () => {
  const previousTaskCommentsCollection: PreviousTaskCommentsCollection = useRxCollection(
    RxdbCollectionName.PREVIOUS_TASK_COMMENTS,
  );

  const [previousTaskCommentsInitialized, setPreviousTaskCommentsInitialized] =
    useState<boolean>(false);

  useEffect(() => {
    if (previousTaskCommentsCollection) setPreviousTaskCommentsInitialized(true);
  }, [previousTaskCommentsCollection]);

  const getPreviousTaskComments = async (
    taskId: number,
  ): Promise<PreviousTaskCommentsDocument[]> => {
    if (!previousTaskCommentsCollection) return [];
    let previousTaskComments: PreviousTaskCommentsDocument[];
    try {
      const queryObj = {
        selector: {
          $and: [{ fkAssetInspectionTask: taskId }, { comment: { $ne: '' } }],
        },
      };
      previousTaskComments = isJestTest()
        ? await previousTaskCommentsCollection?.find(queryObj).exec()
        : await previousTaskCommentsCollection
            ?.find(queryObj)
            .sort({
              dateCreated: `desc`,
            })
            .exec();
      return previousTaskComments;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(
        '🚀 ~ file: usePreviousTaskComments.ts ~ line 36 ~ getPreviousTaskComments ~ error',
        error,
      );
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(
        error,
        '~ file: usePreviousTaskComments.tsx ~ line 36 ~ getPreviousTaskComments ~',
      );
      throw new Error(`error ${error}`);
    }
  };

  const assignBackComment = async (taskId: number): Promise<PreviousTaskCommentsDocument[]> => {
    if (!previousTaskCommentsCollection) return [];
    try {
      const taskComments: PreviousTaskCommentsDocument[] = await previousTaskCommentsCollection
        ?.find({
          selector: {
            fkAssetInspectionTask: Number(taskId),
          },
        })
        .sort({
          dateCreated: `desc`,
        })
        .exec();
      return taskComments;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(
        '🚀 ~ file: usePreviousTaskComments.ts ~ line 55 ~ assignBackComment ~ error',
        error,
      );
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(
        error,
        '~ file: usePreviousTaskComments.tsx ~ line 55 ~ assignBackComment ~',
      );
      throw new Error(`error ${error}`);
    }
  };

  return {
    previousTaskCommentsInitialized,
    previousTaskCommentsCollection,
    getPreviousTaskComments,
    assignBackComment,
  };
};
